
















import {BaseComponent} from '@/mixins/BaseComponent';
import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';
import {Inject} from 'inversify-props';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import {ISystemTimeService} from '@/services/system/ITime.service';

import SystemRegionStore from '@/store/system/SystemRegion.store';
import {Timezone} from '@/model/system/time/timezone';

@Component({
  components: {},
})
export default class TimezoneEditor extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ISystemTimeService'))
  private systemTimeService!: ISystemTimeService;

  private regionStore: SystemRegionStore = getModule(SystemRegionStore, this.$store);

  @Prop()
  private timezone!: Timezone | null;

  private selectedTimezone: Timezone | null = null;
  private selectTimezones: any[] = [];

  private refreshingTimezone = false;
  private refreshingAvailableTimezones = false;

  private async mounted() {
    await this.refreshTimezone();
    await this.refreshAvailableTimezones();
  }

  private async refreshTimezone() {
    this.refreshingTimezone = true;
    try {
      await this.regionStore.fetchTimezone();
      this.selectedTimezone = this.regionStore.Timezone;
      this.$emit('update:timezone', this.selectedTimezone);
      this.logger.info(`Gateway timezone is '${this.selectedTimezone}'`);
    } catch (error) {
      Notify.Error(this.logger, `Could not get current timezone`, error);
    } finally {
      this.refreshingTimezone = false;
    }
  }

  private async onSelectedTimezoneChanged() {
    const selectedTimezone = this.regionStore.AvailableTimezones?.find(
      (tz: Timezone) => tz.Region === this.selectedTimezone?.Region && tz.Timezone === this.selectedTimezone?.Timezone,
    );
    this.$emit('update:timezone', selectedTimezone);
  }

  private async refreshAvailableTimezones() {
    this.refreshingAvailableTimezones = true;
    try {
      this.selectTimezones = [];
      const addedRegions: string[] = [];

      await this.regionStore.fetchAvailableTimezones();

      const timezones = this.regionStore.AvailableTimezones || [];

      for (const timezone of timezones) {

        const label = `${timezone.Timezone.replace('_', ' ')}`;

        if (timezone.Region !== '' && !addedRegions.includes(timezone.Region)) {
          addedRegions.push(timezone.Region);
          this.selectTimezones.push({
            divider: true,
          });
          this.selectTimezones.push({
            header: timezone.Region,
          });
        }

        this.selectTimezones.push({
          Timezone: timezone.Timezone,
          Region: timezone.Region,
          Label: label,
        });

      }

    } catch (error) {
      Notify.Error(this.logger, `Could not get available timezones`, error);
    } finally {
      this.refreshingAvailableTimezones = false;
    }
  }
}
